export const getMaxChipLength = (value: number) => {
	return value > 999 ? "999+" : value.toString();
}
